import "./BaseTextInputAdornments_module.css";
const BaseTextInputAdornments_module = {
    adornmentButton: "adornmentButton__0179fb0312313fe0",
    adornmentSeparator: "adornmentSeparator__0179fb0312313fe0",
    adornmentText: "adornmentText__0179fb0312313fe0",
    adornmentIcon: "adornmentIcon__0179fb0312313fe0",
    disabled: "disabled__0179fb0312313fe0"
};
export { BaseTextInputAdornments_module as default };
